import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BlogPostInfo } from '../api/types';
import { useLanguage } from '../i18n/LanguageContext';

function BlogCard({ post, index, categoryLabel }: { post: BlogPostInfo; index: number; categoryLabel: string }) {
  const { lang } = useLanguage();
  const title = lang === 'en' ? post.title_en : post.title_tr || post.title_en;

  return (
    <Link className="blog-row" to={`/blog/${post.slug}`}>
      <span className="blog-row-index">{String(index).padStart(2, '0')}.</span>
      <div className="blog-row-body">
        <p className="blog-row-title">
          {title}
          <ChevronRight className="blog-row-chevron" size={16} aria-hidden />
        </p>
        <p className="blog-row-meta">
          {post.published_at && new Date(post.published_at).toLocaleDateString(lang === 'en' ? 'en-US' : 'tr-TR')}
          {post.published_at && ' · '}
          {categoryLabel}
        </p>
      </div>
    </Link>
  );
}

export default BlogCard;
